/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import ModalEventPublishedSuccess from "./ModalEventPublishedSuccess";
import ModalEventPublishConfirmation from "./ModalEventPublishConfirmation";
import ModalLoadingState from "../../PopUpModal/ModalLoadingState";
import ModalEventPublishedFailure from "./ModalEventPublishedFailure";
import ModalEventShare from "./ModalEventShare";
import SaveForLaterModal from "../../PopUpModal/SaveForLaterModal";
import StatusModal from "../../PopUpModal/StatusModal";
import ModalComponent from "../../MPS/EventRegistration/EventsModal";
import Button from "../../ui/Button";
import { DocumentUpload } from "./CreateEventContent";
import alert from "../../../assets/images/alert-circle.svg";
import { useNavigate } from "react-router-dom";

const EventLimitReachedModal = ({ handleClose }) => {
  const navigate = useNavigate();
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-md w-full shadow-xl overflow-hidden">
        {/* Top accent */}
        <div className="h-1.5 w-full bg-gradient-to-r from-grey-800 to-grey-600" />
        <div className="p-8">
          <div className="w-12 h-12 rounded-xl bg-grey-100 flex items-center justify-center mb-5">
            <svg className="w-6 h-6 text-grey-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <p className="text-xs text-grey-400 uppercase tracking-widest mb-2">Basic Plan · 2 events/month</p>
          <h2 className="text-2xl font-semibold text-grey-900 mb-3">You've hit your event limit</h2>
          <p className="text-grey-600 mb-6 leading-relaxed">
            The Basic plan includes 2 published events per calendar month. Upgrade to Pro for unlimited events — plus ticketing, document signing, analytics, and more.
          </p>

          <div className="bg-grey-50 rounded-xl p-4 mb-6 space-y-2">
            {["Unlimited published events", "Attendee ticketing (3.7% + $1.79/ticket)", "PDF document signing", "Advanced analytics & reports", "3 team seats"].map(feature => (
              <div key={feature} className="flex items-center gap-2 text-sm text-grey-700">
                <svg className="w-4 h-4 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                </svg>
                {feature}
              </div>
            ))}
          </div>

          <div className="flex gap-3">
            <button
              onClick={handleClose}
              className="flex-1 px-4 py-2.5 border border-grey-300 text-grey-700 rounded-xl text-sm font-medium hover:bg-grey-50 transition"
            >
              Maybe Later
            </button>
            <button
              onClick={() => { handleClose(); navigate('/eo/settings?tab=subscription'); }}
              className="flex-1 px-4 py-2.5 bg-grey-900 text-white rounded-xl text-sm font-medium hover:bg-grey-800 transition"
            >
              Upgrade to Pro — $249/mo
            </button>
          </div>
          <p className="text-xs text-grey-400 text-center mt-3">Your draft has been saved. Publish after upgrading.</p>
        </div>
      </div>
    </div>
  );
};

const ModalRenderer = ({
    popUpModalType,
    formState,
    isModalOpen,
    isDragging,
    fileInputRef,
    documentRef,
    handleClose,
    handleCloseModalOnly,
    handlePublishEvent,
    handleGoToDashboard,
    handleShareEvent,
    handleSaveDraft,
    handleSaveForLater,
    handleCancel,
    handleUploadImageClick,
    handleUploadImageCancel,
    handleCoverPhotoUpload,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    handleUploadMapCancel,
    handleEventMapUpload,
    handleUploadEventDocumentsCancel,
    handleFileUpload,
    setIsModalOpen,
    setPopUpModalType,
    publishedEventId,

}) => {
    const handleEventDocumentsUpload = () => {
        if (formState?.eventDocuments?.length < 5) {
            if (documentRef.current) {
                documentRef.current.click();
            }
        } else {
            setPopUpModalType("document limit reached")
        }
    }
    switch (popUpModalType) {
        //publish event modal
        case "eventPublishConfirmation":
            return (
                <ModalEventPublishConfirmation
                    handleClose={handleClose}
                    handlePublishEvent={handlePublishEvent}
                />
            );
        case "eventPublishedSuccess":
            return (
                <ModalEventPublishedSuccess
                    handleClose={handleClose}
                    handleGoToDashboard={handleGoToDashboard}
                    handleShareEvent={handleShareEvent}
                    eventId={publishedEventId}
                />
            );
        case "eventPublishedFailure":
            return <ModalEventPublishedFailure handleClose={handleClose} />;
        case "eventLimitReached":
            return <EventLimitReachedModal handleClose={handleClose} />;
        case "shareEvent":
            return <ModalEventShare />;
        //save for later modal
        case "saveForLaterConfirmation":
            return (
                <SaveForLaterModal
                    isOpen={isModalOpen}
                    onClose={handleCloseModalOnly}
                    onSaveDraft={handleSaveDraft}
                />
            );
        case "saveDraftSuccess":
            return (
                <StatusModal
                    isOpen={isModalOpen}
                    title="Event has been saved!"
                    message="Your progress has been saved."
                    onClose={handleCloseModalOnly}
                    onNavigate={handleGoToDashboard}
                    isSuccess={true}
                />
            );
        case "saveDraftFailure":
            return (
                <StatusModal
                    isOpen={isModalOpen}
                    title="Error Saving Event"
                    message="There was an error saving your event, please try again or discard your changes."
                    onClose={handleCloseModalOnly}
                    isSuccess={false}
                />
            );
        //   return (
        //     <SaveForLaterModal
        //       isOpen={isModalOpen}
        //       onClose={handleClose}
        //       onSaveDraft={handleSaveDraft}
        //     />
        //   );
        // case "saveDraftSuccess":
        //   return (
        //     <StatusModal
        //       isOpen={isModalOpen}
        //       title="Event has been saved!"
        //       message="Your progress has been saved."
        //       onClose={handleClose}
        //       isSuccess={true}
        //     />
        //   );
        // case "saveDraftFailure":
        //   return (
        //     <StatusModal
        //       isOpen={isModalOpen}
        //       title="Error Saving Event"
        //       message="There was an error saving your event, please try again or discard your changes."
        //       onClose={handleClose}
        //       isSuccess={false}
        //     />
        //   );
        case "cancel event application":
            return (
                <ModalComponent
                    title="Cancel creating event?"
                    message="You're about to cancel  your event. Once you cancel all the changes you've made will be lost. How do you want to continue?"
                    firstButtonLabel="Save For Later"
                    secondButtonLabel="Cancel Event"
                    secondButtonVariant="transparent"
                    onFirstButtonClick={handleSaveForLater}
                    onSecondButtonClick={handleCancel}
                    childrenPosition="below"
                >
                    <div>
                        <Button variant="underline" onClick={() => { setPopUpModalType(null); setIsModalOpen(false); }}>
                            Keep Editing
                        </Button>
                    </div>
                </ModalComponent>
            );
        case "upload image":
            return (
                <ModalComponent
                    title="Upload cover photo"
                    firstButtonLabel="Upload"
                    secondButtonLabel="Cancel"
                    secondButtonVariant="transparent"
                    onFirstButtonClick={handleUploadImageClick}
                    onSecondButtonClick={handleUploadImageCancel}
                >
                    <div
                        className={`flex items-center justify-center max-h-[200px] max-w-full sm:max-w-[391px] bg-grey-25 ${isDragging ? "bg-grey-100 border-2 border-primary-500" : ""
                            }`}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        onClick={() => {
                            if (fileInputRef.current) {
                                fileInputRef.current.click();
                            }
                        }}
                    >
                        {/* Dynamically render content */}
                        {!formState?.eventCoverPhoto ? (
                            <DocumentUpload 
                                isDragging={isDragging} 
                                title="Upload cover photo" 
                                error={formState?.coverPhotoError}
                            />
                        ) : (
                            <img
                                src={URL.createObjectURL(formState?.eventCoverPhoto)}
                                alt="Selected cover photo"
                                className="w-auto h-56 cursor-pointer"
                            />
                        )}
                        <input
                            type="file"
                            ref={fileInputRef}
                            className="hidden"
                            accept="image/*"
                            onChange={handleCoverPhotoUpload}
                        />
                    </div>
                </ModalComponent>
            );
        case "upload event map":
            return (
                <ModalComponent
                    title="Upload event map"
                    message="Upload a map you want to share with marketplace sellers at your event"
                    firstButtonLabel="Upload"
                    secondButtonLabel="Cancel"
                    secondButtonVariant="transparent"
                    onFirstButtonClick={() => {
                        if (formState?.eventMap) {
                            setPopUpModalType(null);
                            setIsModalOpen(false)
                        }
                    }}
                    onSecondButtonClick={handleUploadMapCancel}
                >
                    <>
                        <div
                            className={`flex items-center justify-center max-h-[200px] max-w-full sm:max-w-[391px] bg-grey-25 ${isDragging ? "bg-grey-100 border-2 border-primary-500" : ""
                                }`}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            onClick={() => {
                                if (fileInputRef.current) {
                                    fileInputRef.current.click();
                                }
                            }}
                        >
                            <DocumentUpload isDragging={isDragging} title="Upload event Map" />
                            <input
                                type="file"
                                ref={fileInputRef}
                                className="hidden"
                                accept="application/pdf"
                                onChange={handleEventMapUpload}
                            />
                        </div>
                        {formState?.eventMap && <p className="text-xs w-full text-center text-success-600 font-semibold">
                            {`${formState?.eventMap?.fileName.slice(0, 10)}... added`}
                        </p>}
                    </>
                </ModalComponent>
            );
        case "upload event documents":
            return (
                <ModalComponent
                    title="Upload event documents"
                    message="Upload any documents you need to share with the marketplace sellers at your event"
                    firstButtonLabel="Upload"
                    secondButtonLabel="Cancel"
                    secondButtonVariant="transparent"
                    onFirstButtonClick={() => {
                        if (formState?.eventDocuments?.length > 0) {
                            setPopUpModalType(null);
                            setIsModalOpen(false)
                        }
                    }}
                    onSecondButtonClick={handleUploadEventDocumentsCancel}
                >
                    <div
                        className={`flex items-center justify-center max-h-[200px] max-w-full sm:max-w-[391px] bg-grey-25 ${isDragging ? "bg-grey-100 border-2 border-primary-500" : ""
                            }`}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        onClick={handleEventDocumentsUpload}
                    >
                        <DocumentUpload isDragging={isDragging} title="Upload documents here" />
                        <input
                            id="file-upload"
                            ref={documentRef}
                            type="file"
                            className="hidden"
                            onChange={handleFileUpload}
                            accept=".doc,.pdf,.jpg,.png,.jpeg"
                            multiple
                        />
                    </div>
                    {formState?.eventDocuments?.length > 0 && <ul>
                        {formState?.eventDocuments?.map((document, index) => {
                            const fileName = document.fileName.length > 10 ? `${document.fileName.slice(0, 10)}...` : document.fileName;
                            return (
                                <li className="pt-2 text-sm font-medium text-success-700" key={index}>
                                    {`${fileName} added`}
                                </li>
                            )
                        })}
                    </ul>}
                </ModalComponent>
            );
        case "document limit reached":
            return (
                <ModalComponent
                    icon={<img src={alert} alt="alert" className="size-20" />}
                    title="Document Limit Reached"
                    message="You have already uploaded 5 documents to this event. If you wish to upload another document, please delete one of the documents you have already uploaded."
                    firstButtonLabel="Go Back"
                    firstButtonVariant="transparent"
                    onFirstButtonClick={()=> setPopUpModalType("upload event documents")}
                    childrenPosition="below"
                />
            );

        default:
            return <ModalLoadingState />;
    }
};

export default ModalRenderer;